import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

export interface GetStatusByEntityProps {
  Id: number | number[];
}

interface RawEntityStatusOption {
  nombre: string;
  ids?: number[];
  id?: number;
}

export interface EntityStatusOption {
  nombre: string;
  ids: number[];
}
let entityStatusApiPromise: Promise<AxiosInstance> | null = null;

const getEntityStatusApi = () => {
  if (entityStatusApiPromise) return entityStatusApiPromise;
  entityStatusApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return entityStatusApiPromise;
};

export const getStatusByEntity = async (
  props: GetStatusByEntityProps,
): Promise<EntityStatusOption[] | null> => {
  const api = await getEntityStatusApi();
  if (!api) return null;
  const response = await api.get(
    `/Soporte/GetEstadosByIdEntidad?${objectToQueryStringWithArray(props)}`,
  );

  const data = response.data as RawEntityStatusOption[];

  return (Array.isArray(data) ? data : []).map((item) => ({
    nombre: item.nombre,
    ids: item.ids ?? (typeof item.id === "number" ? [item.id] : []),
  }));
};
